export enum AuthType {
  VenueRead,
  LineLeapRead,
  VenueAdmin,
  LineLeapAdmin
}
